
// Load polyfills if needed

const modernBrowser = ( 'fetch' in window && 'assign' in Object );
if ( !modernBrowser ) {
	const scriptElement = document.createElement('script');
	scriptElement.async = false;
	scriptElement.src = '../../assets/js/polyfills.bundle.js';
	document.head.appendChild(scriptElement);
	console.info('loaded polyfills');
}

// require('es6-promise').polyfill();
require('es6-promise').polyfill();

// require('isomorphic-fetch');

import $ from 'jquery';

window.$ = window.jQuery = $;
import 'bootstrap';
import 'svgxuse';
import 'slick-carousel';
import 'perfect-scrollbar';
import 'handlebars';
import 'orgchart';
// import 'querystring';
// import wickedpicker from 'wickedpicker';
